export default __webpack_public_path__ + "static/media/portrait601.bce3d3bd.JPG";